export default "__VITE_ASSET__TnZqiVcd__"